<template>
  <Modal v-model="model" sticky reset-drag-position title="编辑热线号码" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="single_row_div" width="700">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    <div class="pstn_content">
      <div class="input_single">
        <div class="font_style_set">热线号码:</div>
        <Input v-model="pstnNumber" class="input_content" readonly="readonly"  placeholder="请输入热线号码"/>
      </div>
      <div class="input_single">
        <div class="font_style_set">热线名称:</div>
        <Input v-model="pstnNumberName" class="input_content" placeholder="请输入热线名称"/>
      </div>
      <div style="margin-bottom: 15px" class="input_descr">
        <div class="font_style_set">热线号码区号:</div>
        <Input v-model="areaCode" class="input_content" placeholder="请输入热线号码区号"/>
      </div>
      <!--<div class="input_single">-->
        <!--<div class="font_style_set">是否启用黑白名单:</div>-->
        <!--<Select class="input_content" v-model="pstnBw" placeholder="是否启用黑白名单" @on-change="handleStatus">-->
          <!--<Option v-for="(option, index) in judgeList" :value="option.id" :key="index">{{option.name}}</Option>-->
        <!--</Select>-->
      <!--</div>-->
      <!--<div class="input_single" v-show="pstnBw!='0'">-->
        <!--<div class="font_style_set">{{pstnBwGidName}}:</div>-->
        <!--<Select class="input_content" v-model="pstnBwGid" placeholder="请选择名单组">-->
          <!--<Option v-for="(option, index) in pstnBwGidList" :value="option.id" :key="index">{{option.name}}</Option>-->
        <!--</Select>-->
      <!--</div>-->
      <div class="input_single">
        <div class="font_style_set">挂机短信:</div>
        <RadioGroup class="input_content" v-model="isAutoSms" type="button" placeholder="请选择是否启用挂机短信">
          <Radio v-for="(option, index) in isEnable" :label="option.id" :key="index">{{option.name}}</Radio>
        </RadioGroup>
      </div>
      <div v-if="isAutoSms=='1'" style="margin-bottom: 15px" class="input_descr">
        <div class="font_style_set"><span style="color: red">*</span>短信内容:</div>
        <Input v-model="autoSmsContent" class="input_content" type="textarea"/>
      </div>
      <div class="input_descr" style="margin-bottom: 15px">
        <div class="font_style_set">备注:</div>
        <Input v-model="desc" class="input_content" type="textarea"/>
      </div>
      <div class="input_single">
        <div class="font_style_set">启用分时段业务:</div>
        <RadioGroup class="input_content" v-model="isCall" type="button" placeholder="请选择是否启用分时段业务">
          <Radio v-for="(option, index) in isEnable" :label="option.id" :key="index">{{option.name}}</Radio>
        </RadioGroup>
      </div>
      <div  v-show="isCall=='0'">
        <div class="input_single">
          <div class="font_style_set">业务类型:</div>
          <Select class="input_content" v-model="numberType" placeholder="请选择业务类型" clearable>
            <Option v-for="(option, index) in numberTypeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </div>
        <div class="input_single" v-if="numberType=='5' || numberType=='3'">
          <div class="font_style_set"><span style="color: red">*</span>号码:</div>
          <Input v-model="numberList" class="input_content" placeholder="请输入号码"/>
          <el-tooltip class="el_tips_font" effect="light" placement="top" content="号码之间用英文逗号相隔"><img :src="questionMark"/></el-tooltip>
        </div>
        <div class="input_single" v-if="numberType=='2'">
          <div class="font_style_set"><span style="color: red">*</span>语音导航:</div>
          <Select class="input_content" v-model="ivrId" placeholder="请选择语音导航">
            <Option v-for="(option, index) in ivrList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </div>
        <div class="input_single" v-if="numberType=='9'">
          <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
          <Select class="input_content" v-model="queueNum" placeholder="请选择技能组号码">
            <OptionGroup label="普通技能组">
              <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
            </OptionGroup>
            <OptionGroup label="AI技能组" v-show="supportAI">
              <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
            </OptionGroup>
          </Select>
        </div>
      </div>
      <Tabs v-show="isCall=='1'">
        <TabPane label="工作时间" icon="ios-call">
          <div class="input_single">
            <div class="font_style_set">业务类型:</div>
            <el-select v-model="numberTypeWorktime" class="input_content" placeholder="请选择业务类型" clearable>
              <el-option v-for="(option, index) in numberTypeList" :key="index" :label="option.name" :value="option.id"></el-option>
            </el-select>
          </div>
          <div class="input_single" v-if="numberTypeWorktime=='5' || numberTypeWorktime=='3'">
            <div class="font_style_set"><span style="color: red">*</span>号码:</div>
            <Input v-model="numlstWorktime" class="input_content" placeholder="请输入号码"/>
            <el-tooltip class="el_tips_font" effect="light" placement="top" content="号码之间用英文逗号相隔"><img :src="questionMark"/></el-tooltip>
          </div>
          <div class="input_single" v-if="numberTypeWorktime=='2'">
            <div class="font_style_set"><span style="color: red">*</span>语音导航:</div>
            <el-select v-model="ivrIdWorktime" class="input_content" placeholder="请选择语音导航" clearable>
              <el-option v-for="(option, index) in ivrList" :key="index" :label="option.name" :value="option.id"></el-option>
            </el-select>

          </div>
          <div class="input_single" v-if="numberTypeWorktime=='9'">
            <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
            <el-select v-model="queueWorktime" class="input_content" placeholder="请选择技能组号码" clearable>
              <el-option-group label="普通技能组">
                <el-option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</el-option>
              </el-option-group>
              <el-option-group label="AI技能组" v-if="supportAI">
                <el-option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</el-option>
              </el-option-group>
            </el-select>
          </div>
        </TabPane>
        <TabPane label="节假日" icon="ios-home">
          <div class="input_single">
            <div class="font_style_set">业务类型:</div>
            <el-select v-model="numberTypeHoli" class="input_content" placeholder="请选择业务类型" clearable>
              <el-option v-for="(option, index) in numberTypeList" :key="index" :label="option.name" :value="option.id"></el-option>
            </el-select>
          </div>
          <div class="input_single" v-if="numberTypeHoli=='5' || numberTypeHoli=='3'">
            <div class="font_style_set"><span style="color: red">*</span>号码:</div>
            <Input v-model="numlstHoli" class="input_content" placeholder="请输入号码"/>
            <el-tooltip class="el_tips_font" effect="light" placement="top" content="号码之间用英文逗号相隔"><img :src="questionMark"/></el-tooltip>
          </div>
          <div class="input_single" v-if="numberTypeHoli=='2'">
            <div class="font_style_set"><span style="color: red">*</span>语音导航:</div>
            <el-select v-model="ivrIdHoli" class="input_content" placeholder="请选择语音导航" clearable>
              <el-option v-for="(option, index) in ivrList" :key="index" :label="option.name" :value="option.id"></el-option>
            </el-select>
          </div>
          <div class="input_single" v-if="numberTypeHoli=='9'">
            <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
            <el-select v-model="queueHoli" class="input_content" placeholder="请选择技能组号码" clearable>
              <el-option-group label="普通技能组">
                <el-option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</el-option>
              </el-option-group>
              <el-option-group label="AI技能组" v-if="supportAI">
                <el-option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</el-option>
              </el-option-group>
            </el-select>
          </div>
        </TabPane>
        <TabPane label="下班时间" icon="ios-cafe">
          <div class="input_single">
            <div class="font_style_set">业务类型:</div>
            <el-select v-model="numberTypeTohome" class="input_content" placeholder="请选择业务类型" clearable>
              <el-option v-for="(option, index) in numberTypeList" :key="index" :label="option.name" :value="option.id"></el-option>
            </el-select>
          </div>
          <div class="input_single" v-if="numberTypeTohome=='5' || numberTypeTohome=='3'">
            <div class="font_style_set"><span style="color: red">*</span>号码:</div>
            <Input v-model="numlstTohome" class="input_content" placeholder="请输入号码" title="号码"/>
            <el-tooltip class="el_tips_font" effect="light" placement="top" content="号码之间用英文逗号相隔"><img :src="questionMark"/></el-tooltip>
          </div>
          <div class="input_single" v-if="numberTypeTohome=='2'">
            <div class="font_style_set"><span style="color: red">*</span>语音导航:</div>
            <el-select v-model="ivrIdTohome" class="input_content" placeholder="请选择语音导航" clearable>
              <el-option v-for="(option, index) in ivrList" :key="index" :label="option.name" :value="option.id"></el-option>
            </el-select>
          </div>
          <div class="input_single" v-if="numberTypeTohome=='9'">
            <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
            <el-select v-model="queueTohome" class="input_content" placeholder="请选择技能组号码" clearable>
              <el-option-group label="普通技能组">
                <el-option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</el-option>
              </el-option-group>
              <el-option-group label="AI技能组" v-if="supportAI">
                <el-option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</el-option>
              </el-option-group>
            </el-select>
          </div>
        </TabPane>
      </Tabs>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "PstnNumberPop",
      props:{
        showPstnNumber:Boolean,
        pstnNumberId:String,
        queueList:Array,
        queueList2:Array
      },
      data(){
        return {
          model:false,
          spinShow:true,
          questionMark:require('../../../assets/image/homeAsk.png'),
          pstnNumber:'',
          pstnBw:'1',
          pstnBwGid:'',
          pstnBwGidName:'黑名单组',
          pstnBwGidList:[],
          blackList:[],
          whiteList:[],
          pstnNumberName:'',
          isCall:'1',
          oldNumberType:'',
          ivrList:[],
          judgeList:[{'id':'0','name':'不启用'},{'id':'1','name':'启用呼入黑名单'},{'id':'2','name':'启用呼入白名单'}],
          numberTypeList:[{'id':'5','name':'一号通'},{'id':'3','name':'同振'},{'id':'2','name':'语音导航'},{'id':'9','name':'技能组'}],
          isAutoSms:'0',
          isEnable:[{'id':'0','name':'不启用'},{'id':'1','name':'启用'}],
          autoSmsContent:'',
          desc:'',
          oldIvrId:'',
          oldNumberTypeHoli:'',
          oldIvrIdTohome:'',
          oldNumberTypeTohome:'',
          oldNumberTypeWorktime:'',
          oldIvrIdHoli:'',
          oldPstnNumberBw:'',
          oldPstnGid:'',
          oldIvrIdWorktime:'',
          numberType:'',
          numberList:'',
          ivrId:'',
          queueNum:'',
          numberTypeWorktime:'',
          numlstWorktime:'',
          ivrIdWorktime:'',
          queueWorktime:'',
          numberTypeHoli:'',
          numlstHoli:'',
          ivrIdHoli:'',
          queueHoli:'',
          numberTypeTohome:'',
          numlstTohome:'',
          ivrIdTohome:'',
          queueTohome:'',
          areaCode:'',
          supportAI:localStorage.getItem('supportAI')==='1'?true:false,
        }
      },
      methods:{
        handleStatus:function(){
          if(this.pstnBw=='1'){
            this.pstnBwGidName="黑名单组";
            this.pstnBwGidList=this.blackList;
          }
          if(this.pstnBw=='2'){
            this.pstnBwGidName="白名单组";
            this.pstnBwGidList=this.whiteList;
          }
        },
        cancel:function () {
          this.$emit("closePstnNumber",false)
        },
        save:function () {
          let that=this;
          if(this.isAutoSms=="1" && !this.autoSmsContent){
            this.$alert("启用挂机短信时短信内容不能为空", '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          let numberList="";
          if(this.numberType=='5' || this.numberType=='3'){
            numberList=this.numberList;
          }
          if(this.numberType=='9'){
            numberList=this.queueNum;
          }
          let numLstWorkTime="";
          if(this.numberTypeWorktime=='5' || this.numberTypeWorktime=='3'){
            numLstWorkTime=this.numlstWorktime;
          }
          if(this.numberTypeWorktime=='9'){
            numLstWorkTime=this.queueWorktime;
          }
          let numLstHoLi="";
          if(this.numberTypeHoli=='5' || this.numberTypeHoli=='3'){
            numLstHoLi=this.numlstHoli;
          }
          if(this.numberTypeHoli=='9'){
            numLstHoLi=this.queueHoli;
          }
          let numLstToHome="";
          if(this.numberTypeTohome=='5' || this.numberTypeTohome=='3'){
            numLstToHome=this.numlstTohome;
          }
          if(this.numberTypeTohome=='9'){
            numLstToHome=this.queueTohome;
          }
          let param={
            id:this.pstnNumberId,
            isCall:this.isCall,
            isAutoSms:this.isAutoSms,
            pstnNumber:this.pstnNumber,
            pstnNumberName:this.pstnNumberName,
            descr:this.desc,
            autoSmsContent:this.autoSmsContent,
            pstnBw:this.pstnBw,
            pstnGid:this.pstnBwGid,
            oldPstnBw:this.oldPstnBw,
            oldPstnGid:this.oldPstnGid,
            oldNumberTypeWorktime:this.oldNumberTypeWorktime,
            oldIvrIdWorktime:this.oldIvrIdWorktime,
            oldNumberTypeHoli:this.oldNumberTypeHoli,
            oldIvrIdHoli:this.oldIvrIdHoli,
            oldNumberTypeTohome:this.oldNumberTypeTohome,
            oldIvrIdTohome:this.oldIvrIdTohome,
            ivrId:this.ivrId,
            numberType:this.numberType,
            numberList:numberList,
            numberTypeWorktime:this.numberTypeWorktime,
            ivrIdWorktime:this.ivrIdWorktime,
            numberListWorktime:numLstWorkTime,
            numberTypeHoli:this.numberTypeHoli,
            ivrIdHoli:this.ivrIdHoli,
            numberListHoli:numLstHoLi,
            numberTypeTohome:this.numberTypeTohome,
            ivrIdTohome:this.ivrIdTohome,
            numberListTohome:numLstToHome,
            journalType:"系统管理=>CTI配置=>热线号码编辑",
            menuId:"3_5-1-1",
            areaCode:this.areaCode
          };
          this.spinShow=true;
          this.$http.post("pstnNumber/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$alert("热线号码修改成功", '提示', {
              confirmButtonText: '确定'
            });
            that.$emit("closePstnNumber",true)
          });
        },
        init:function () {
          let that=this;
          let param={
            id:this.pstnNumberId,
            journalType:"系统管理=>CTI配置=>热线号码查询",
            menuId:"null"
          };
          this.$http.post("pstnNumber/doSelectOne.json",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            let obj=res.data.obj;
            that.blackList=obj.blackList;
            that.whiteList=obj.whiteList;
            that.pstnBw=obj.pstnBw;
            that.pstnNumber=obj.pstnNumber;
            that.pstnNumberName=obj.pstnNumberName;
            that.pstnBwGid=obj.pstnBwGid;
            that.isAutoSms=obj.isAutoSms+'';
            that.autoSmsContent=obj.autoSmsContent;
            that.desc=obj.desc;
            that.isCall=obj.isCall;
            that.ivrList=obj.ivrList;
            that.numberTypeWorktime=obj.numberTypeWorktime;
            that.ivrIdWorktime=obj.ivrIdWorktime;
            that.numberTypeHoli=obj.numberTypeHoli;
            that.ivrIdHoli=obj.ivrIdHoli;
            that.numberTypeTohome=obj.numberTypeTohome;
            that.ivrIdTohome=obj.ivrIdTohome;
            that.ivrId=obj.ivrId;
            that.oldPstnBw=obj.pstnBw;
            that.oldPstnGid=obj.pstnBwGid;
            that.oldNumberTypeHoli=obj.numberTypeHoli;
            that.oldIvrIdTohome=obj.ivrIdTohome;
            that.oldNumberTypeTohome=obj.numberTypeTohome;
            that.oldNumberTypeWorktime=obj.numberTypeWorktime;
            that.oldIvrIdHoli=obj.ivrIdHoli;
            that.oldIvrIdWorktime=obj.ivrIdWorktime;
            that.oldPstnNumberBw=obj.pstnBw;
            that.numberType=obj.numberType+'';
            that.oldNumberType=obj.numberType+'';
            that.areaCode=obj.areaCode;
            that.numberList="";
            that.queueNum="";
            that.numlstTohome="";
            that.queueTohome="";
            that.numlstWorktime="";
            that.queueWorktime="";
            that.numlstHoli="";
            that.queueHoli="";
            if(obj.numberType=='3' || obj.numberType=='5'){
              that.numberList=obj.numberList;
            }
            if(obj.numberType=='9'){
              that.queueNum=obj.numberList;
            }

            if(obj.numberTypeTohome=='3' || obj.numberTypeTohome=='5'){
              that.numlstTohome=obj.numlstTohome;
            }
            if(obj.numberTypeTohome=='9'){
              that.queueTohome=obj.numlstTohome;
            }

            if(obj.numberTypeWorktime=='3' || obj.numberTypeWorktime=='5'){
              that.numlstWorktime=obj.numlstWorktime;
            }
            if(obj.numberTypeWorktime=='9'){
              that.queueWorktime=obj.numlstWorktime;
            }

            if(obj.numberTypeHoli=='3' || obj.numberTypeHoli=='5'){
              that.numlstHoli=obj.numlstHoli;
            }
            if(obj.numberTypeHoli=='9'){
              that.queueHoli=obj.numlstHoli;
            }
            that.handleStatus();
          });
        }
      },
      watch:{
        showPstnNumber:function () {
          this.model=this.showPstnNumber;
          if(this.showPstnNumber){
            this.spinShow=true;
            this.init();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/PstnNumberPop.vue